package com.macrofocus.eflux.ui.layer

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.deckgl.toJSonArray
import com.macrofocus.eflux.network.substation.Substation
import com.macrofocus.eflux.ui.morphing.morphCoordinates
import deckgl.TextLayer
import js.objects.unsafeJso
import mui.material.styles.Theme
import org.locationtech.jts.geom.Point
import org.molap.dataframe.DataFrame

fun createLabelLayer(dataLoader: DataLoader,
                     labelSubstations: Boolean,
                     labels: DataFrame<Int, String, Any?>?,
                     cartographic: Double,
                     theme: Theme,
                     isCartographicZoomed: Boolean): TextLayer<Int> {
    val stroke = theme.asDynamic().label

    val array = if(labels != null) Array(labels.rowCount) { i ->
        labels.getRowKey(i)
    } else emptyArray()
    val labelLayer = TextLayer<Int>(unsafeJso {
        id = "label-layer"
        this.data = array

        visible = labelSubstations

        opacity = 1.0 - (cartographic / 10.0) // if (isCartographicZoomed) 0.05 else 1.0
        asDynamic().positionFormat = "XY"
        asDynamic().getPosition = { row: Int ->
            val physical = labels!!.getValueAt(row, "physicalGeometry") as Point?
            val logical = labels.getValueAt(row, "logicalGeometry") as Point
            val morphed: Array<Double>?
            if (physical != null) {
                morphed =
                    morphCoordinates(logical.coordinate!!, physical.coordinate!!, cartographic, 10).toJSonArray()
            } else {
                if (cartographic <= 10 / 2) {
                    morphed = logical.toJSonArray()
                } else {
                    morphed = emptyArray()
                }
            }
            morphed
        }
        asDynamic().getText = { row: Int ->
            labels!!.getValueAt(row, "text")
        }
        asDynamic().getColor = { row: Int ->
            stroke
        }
        asDynamic().fontWeight = "bold"
        asDynamic().getSize = { row: Int ->
            val substationId = labels!!.getValueAt(row, "substationId")
            val logicalBusId = labels.getValueAt(row, "logicalBusId")
            if(substationId != null || logicalBusId != null)
                0.05
            else
                0.065
        }
        asDynamic().characterSet = "auto"
        asDynamic().sizeUnits = "common"
        asDynamic().fontFamily = "Roboto"
        asDynamic().getTextAnchor = "start"
        asDynamic().getAlignmentBaseline = "bottom"
        pickable = true
        updateTriggers = unsafeJso {
            this.asDynamic().opacity = arrayOf(isCartographicZoomed)
            this.asDynamic().getPosition = arrayOf(cartographic)
            this.asDynamic().getColor = arrayOf(theme, isCartographicZoomed)
        }
        transitions = unsafeJso {
            this.asDynamic().getColor = 1000
        }
        onHover = { info ->
            val o = info.`object`
            if (o != null) {
                val s = o.logicalBusId.unsafeCast<String?>()
                if (o is Substation) {
                    val logicalBusId = o.logicalBusId
                    dataLoader.configuration.logicalBusProbing.selected = logicalBusId
                } else {
                    dataLoader.configuration.logicalBusProbing.clearSelection()
                }
            } else {
                dataLoader.configuration.logicalBusProbing.clearSelection()
            }
        }

        asDynamic().onClick = { info: dynamic ->
            console.log("Click on $info")
            console.log("Click on ${info.`object`}")
            console.log("Click on ${info.`object`.properties}")
        }
    })
    return labelLayer
}
